import { appendIf } from '@btime/helpers'

const validate = (form, variableKeys, setErrors) => {
  const errors = []
  const payload = form?.payload
  const numberOk = String(payload?.number ?? '').trim()

  errors.push(
    ...appendIf(!numberOk, { path: ['payload', 'number'], message: 'Campo obrigatório' }),
    ...appendIf(!payload?.template?.name, { path: ['payload', 'template'], message: 'Campo obrigatório' })
  )

  if (variableKeys && variableKeys.length > 0) {
    variableKeys.forEach(key => {
      const value = payload?.template?.variables?.[key]
      if (!String(value ?? '').trim()) {
        errors.push({
          path: ['payload', 'template', 'variables', key],
          message: 'Campo obrigatório'
        })
      }
    })
  }

  setErrors(errors)
  return errors.length === 0
}

export default validate
